import { useEffect } from "react";
import { getMemberHospitalization } from "../../../apiHandler/actions/profile";
import { displayDateFormatter, DataGridCustomPagination } from "../../helpers";
import { Skeleton } from "@material-ui/lab";

import { DataGrid } from "@mui/x-data-grid";

const columns = [
  { field: "reason", headerName: "Reason", flex: 1 },
  { field: "hospitalName", headerName: "Hospital Name", flex: 1 },
  { field: "duration", headerName: "Duration", flex: 1 },
  { field: "date", headerName: "Date", flex: 1 },
];

const Component = (props) => {
  const { hospitalization, setHospitalization } = props;

  useEffect(() => {
    if (hospitalization === null) fetchAllergies();
    // eslint-disable-next-line
  }, []);

  const fetchAllergies = async () => {
    const response = await getMemberHospitalization(props.uuid);
    setHospitalization(
      response.hospitalization &&
        response.hospitalization.map((h) => {
          return {
            id: h.id,
            reason: h.reason,
            duration: h.duration,
            hospitalName: h.location?.[0]["text"],
            date: displayDateFormatter(h.date),
          };
        })
    );
  };

  return (
    <div>
      {hospitalization === null ? (
        <div className="mj-skeleton-container">
          <Skeleton variant="text" height={40} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
        </div>
      ) : Array.isArray(hospitalization) && hospitalization.length !== 0 ? (
        <DataGrid
          rows={hospitalization}
          columns={columns}
          autoHeight="true"
          disableRowSelectionOnClick
          pagination
          pageSize={5}
          slots={{
            pagination: DataGridCustomPagination,
          }}
        />
      ) : (
        <p className="mj-no-records">No records to display</p>
      )}
    </div>
  );
};

export default Component;
